import apiClient from '@u/apiClient'
import GetScreenConfigListController from '@/wayfinder/actions/App/Http/Controllers/Screen/GetScreenConfigListController'
import GetScreenConfigByIdController from '@/wayfinder/actions/App/Http/Controllers/Screen/GetScreenConfigByIdController'
import CreateScreenConfigController from '@/wayfinder/actions/App/Http/Controllers/Screen/CreateScreenConfigController'
import UpdateScreenConfigController from '@/wayfinder/actions/App/Http/Controllers/Screen/UpdateScreenConfigController'
import GetScreenConfigLastDossierController from '@/wayfinder/actions/App/Http/Controllers/Screen/GetScreenConfigLastDossierController'
import GetNewModelController from '@/wayfinder/actions/App/Http/Controllers/NewModel/GetNewModelController'

export default {
  fetchScreenConfigsList({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(GetScreenConfigListController.get())
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },
  fetchNewScreenConfig({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(GetNewModelController.get({ query: { model: 'ScreenConfig' } }))
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },
  fetchScreenConfig({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(
          GetScreenConfigByIdController.get({
            screenConfig: payload.screen_config_id
          })
        )
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },
  storeScreenConfig({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(CreateScreenConfigController.post(), payload)
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },
  updateScreenConfig({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(
          UpdateScreenConfigController.put({ screenConfig: payload.id }),
          payload
        )
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },
  getLastDossier({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(GetScreenConfigLastDossierController.get(), payload)
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  }
}
